import React, { useEffect } from "react";
import { Add, FormClose, StatusGood } from "grommet-icons";
import { Box, Button, Layer, Text } from "grommet";
import { observer } from "mobx-react";
import { useStore } from "../../../../../Hooks/useStore";
import './SuccessMsg.css';
import requestSend from '../../../../../assets/requestSent.svg';
import requestClose from '../../../../../assets/request-notification-close.svg';

export const SuccessMsg = observer(() => {

  const { rootStore } = useStore();

  useEffect(() => {
    if (rootStore.successStore.getShow) onOpen();
  }, [rootStore.successStore.getShow]);

  const onOpen = () => {
    setTimeout(() => {
      rootStore.successStore.handleShow(false);
    }, 3000);
  };

  return (
    <>
      {rootStore.successStore.getShow && (
        <Layer
          position="right"
          modal={false}
          margin={{ vertical: "medium", horizontal: "small" }}
          onEsc={() => rootStore.successStore.handleShow(false)}
          responsive={false}
          plain
          className="success-msg-main"
        >
          <Box
            align="center"
            direction="row"
            gap="small"
            justify="between"
            round="medium"
            elevation="medium"
            pad={{ vertical: "xsmall", horizontal: "small" }}
            background="status-ok"
          >
            <Box direction="row" className="request-outer">
                <img src={requestSend} className="request-send-img"/>
                <Text className="request-txt">Request to {rootStore.successStore.getNotificationType == "report" ? "update" : "scan"} <span className="heightlighted-txt">{rootStore.successStore.getText}</span> {rootStore.successStore.getNotificationType == "report" ? "readings has been sent to " : " has been sent to "}<span className="heightlighted-txt">{rootStore.successStore.getCrewName}</span></Text>
                <img onClick={() => rootStore.successStore.handleShow(false)} src={requestClose} className="request-close-img"/>
            </Box>
          
              
          </Box>
        </Layer>
      )}
    </>
  );
});
